/**
 * Where the gateway is.
 *
 * Same origin by default, over the page's own scheme: Caddy proxies `/ws` to the gateway, which is
 * what keeps the workspace a static bundle with no third-party origin to allow in the policy. A
 * split-origin development setup overrides it.
 */
export function gatewayUrl(
  location: { protocol: string; host: string } | undefined = globalThis.location,
): string {
  const configured = import.meta.env.VITE_GATEWAY_URL;
  if (configured !== undefined && configured !== '') {
    return configured;
  }
  const scheme = location?.protocol === 'https:' ? 'wss' : 'ws';
  return `${scheme}://${location?.host ?? 'localhost'}/ws`;
}
